import React from "react";
import dynamic from "next/dynamic";
import shouldLoadDyna from '@gc-npm/core.utils.should-load-dyna';
import RouteHandler from "@gc-npm/core.route-handler";
import Saam from "@gc-npm/core.scripts.saam";
import OneTrust from "@gc-npm/components.one-trust-x";
import Modal from "@gc-npm/components.modal";
const Dyna = dynamic(() => import("@gc-npm/core.scripts.dyna"));
import ErrorBoundary from "@/component/error-boundary";
import { wrapper } from "@/store";
// IMPORTS
import "@/styles/globalVars.scss";
/* [STYLES] begins */
/* [STYLES] ends */
import "@/styles/globals.scss";
import "@/styles/grid.scss";
import "@/styles/colors.scss";
import "@/styles/fonts.scss";
import "@/vendor/components.cms-block.recoms-carousel/styles.scss";
import "@/component/card/style.scss";

const App = ({ Component, pageProps, ...rest }) => {
  // useEffect(() => { shouldLoadOneTrust(setCookieVisibility) }, []);

  return (
    <>
      <RouteHandler />
      <ErrorBoundary>
        <Component {...pageProps} />
        <Modal />
        <OneTrust />
      </ErrorBoundary>
      <Saam />
      {shouldLoadDyna() && <Dyna />}
      {/* APP DELIMITER */}
    </>
  );
};

export default wrapper.withRedux(App);
